<script setup>
import {defineProps, computed, watch, defineEmits, onMounted, ref, nextTick} from 'vue'
import Jumbo from '@/components/Docs/Jumbo.vue'
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'
import JsonBlock from '@/components/Docs/JsonBlock.vue'

import StringParam from '@/components/Docs/Parameters/StringParam.vue'
import RequestRunner from '@/components/Docs/RequestRunner.vue'

import BasicAttribute from '@/components/Docs/Attributes/BasicAttribute.vue'

let request_ip = ref("1.1.1.1")
let request_offset = ref("")
let request_limit = ref("")

let get_query = computed(() => {
  var query = "/query/fingerprint/ip/" + request_ip.value 
  
  if (request_limit.value != "" || request_offset.value != "") query += "?"
  
  if (request_limit.value != "") {
    query += "limit="+request_limit.value
  }
  if (request_offset.value != "") {
    if (request_limit.value != "") query += "&"
    query += "offset="+request_offset.value
  }

  return query
}) 

</script>

<template>
  <div>
    <doc-section title="IP fingerprints">
      <template v-slot:left>
        <div class="mb-5">
          <div class="mb-3">
This endpoint allows for retrieving fingerprints associated with ip addresses. Webscout currently supports the full JA4+ and JA3 suite of fingerprints.
          </div>
          <table class="table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>100</td>
                <td>JA3S</td>
              </tr>
              <tr>
                <td>101</td>
                <td>JA3 Inbound</td>
              </tr>
              <tr>
                <td>200</td>
                <td>JA4</td>
              </tr>
              <tr>
                <td>201</td>
                <td>JA4SSH</td>
              </tr>
              <tr>
                <td>201</td>
                <td>JA4T</td>
              </tr>
              <tr>
                <td>202</td>
                <td>JA4T</td>
              </tr>
              <tr>
                <td>203</td>
                <td>JA4H</td>
              </tr>
              <tr>
                <td>204</td>
                <td>JA4 Inbound</td>
              </tr>
              <tr>
                <td>205</td>
                <td>JA4H Inbound</td>
              </tr>
              <tr>
                <td>206</td>
                <td>JA4LS</td>
              </tr>
              <tr>
                <td>207</td>
                <td>JA4S</td>
              </tr>
              <tr>
                <td>208</td>
                <td>JA4SSH Inbound</td>
              </tr>
              <tr>
                <td>209</td>
                <td>JA4TS</td>
              </tr>
              <tr>
                <td>500</td>
                <td>Jarm</td>
              </tr>
            </tbody>
          </table>

        </div>
      
        <div class="mb-5">
          <h4 class="mb-4">Request parameters</h4>
          <StringParam class="mb-3" name="ip" :required="true" description="The fingerprint you wish to lookup" type="string" :value="request_ip" @value="(v) => request_ip = v" />
          <StringParam class="mb-3" name="offset" description="The amount of fingerprints you have already retrieved" type="integer" :value="request_offset" @value="(v) => request_offset = v" />
          <StringParam class="mb-3" name="limit" description="The amount of fingerprints returned on each request. Defaults to 100 which is also the maximum" type="integer" :value="request_limit" @value="(v) => request_limit = v" />

          <RequestRunner class="mt-5" :query="get_query" name="Domain information" method="GET"></RequestRunner>
        </div>

        <div>
          <h4 class="mb-4">Response attributes</h4>


          <BasicAttribute name="status" type="string" description="The status of the request's response" />
          <hr>

          <BasicAttribute name="data" type="object array" description="The requested information">

            <BasicAttribute name="type" type="integer" description="The type of fingerprint, see reference table above" />
            <hr>

            <BasicAttribute name="fingerprint" type="string" description="The fingerprint" />

            <BasicAttribute name="last_seen" type="string" description="When the fingerprint was observed" />
            <hr>

            <BasicAttribute name="port" type="integer" description="On/from which port the fingerprint was observed" />
  
          </BasicAttribute>


        </div>

      </template>

      <template v-slot:right>
        <code-block title="/query/fingerprint/ip/:ip" method="GET" dark/>
      
        <json-block title="Response">

{
"status": 
"success",
"data": 
[

{
"type": 
101,
"fingerprint": 
"000389270d7c064b1b87dacf6e03e737",
"last_seen": 
"2025-04-18T11:54:19Z",
"port": 
443
},
{
"type": 
101,
"fingerprint": 
"000409720c2c20aedefb094afd7c258f",
"last_seen": 
"2025-04-20T14:32:41Z",
"port": 
443
}
]
}
        </json-block>
      </template>
    </doc-section>
  </div>
</template>

<style scoped>
  
.table {
  width: 100%;
  table-layout: fixed;
}

.table th {
  color: white;
  font-weight: normal;
}

.table tr {
  border-bottom: 1px solid #29323E;
}

.table tbody tr:last-child {
  border-bottom: 1px solid transparent;
}

.table td {
  color: #6D7785;
}
</style>
